module.exports = __webpack_public_path__ + "static/media/notice2_2.988070e4.png";